import classNames from 'classnames';
import React from 'react';
import styles from './BulletIndicator.module.scss';

/** Variants, as defined by _colors.scss */
export type BulletVariant =
  | 'neutral'
  | 'muted'
  | 'primary'
  | 'success'
  | 'alert'
  | 'danger'
  | 'info'
  | 'accentA'
  | 'accentB';

export type BulletPattern = 'solid' | 'dashed';

export interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'size'> {
  variant?: BulletVariant;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  pattern?: BulletPattern;
  shape?: 'circle' | 'square';
}

const BulletIndicator = (props: Props) => {
  const {
    variant = 'neutral',
    pattern = 'solid',
    size = 'medium',
    shape = 'circle',
    className,
    ...rest
  } = props;
  const containerClass = classNames(
    styles.bulletContainer,
    styles[`size-${size}`],
    styles[`variant-${variant}`],
    styles[`pattern-${pattern}`],
    styles[`shape-${shape}`],
    className
  );
  return <div {...rest} className={containerClass} />;
};

export default BulletIndicator;
